import React from "react";
import "./Point.scss";
import { getFlag } from "../../../utils/images";
import { formatLocationDate } from "../../../utils/utils";

const Point = ({ location, className }) => {
  return (
    <div className={`Point ${className}`}>
      <div>
        {formatLocationDate(location.date)}
      </div>
      <div>
        <img src={getFlag(location.code)} />
      </div>
      <div className="location-name">
        {location.name}
      </div>
    </div>
  )
}

export default Point;